var FILTER_SUID_PATTERN = /^(?:[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{5}|T[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{5})$/;
export function normalizeFilterSuids(values) {
    var normalizedValues = Array.from(values, function (value) {
        return value.trim().toUpperCase();
    }).filter(function (value) { return FILTER_SUID_PATTERN.test(value); });
    return Array.from(new Set(normalizedValues));
}
export function setFilterSuids(searchParams, paramKey, values) {
    searchParams.delete(paramKey);
    normalizeFilterSuids(values).forEach(function (value) {
        searchParams.append(paramKey, value);
    });
}
